import React from "react";
import styles from "./TestimonialsSection.module.css";
import ProfileSection from "./ProfileSection";

const TestimonialCard = ({ name, role, text, avatar, badge, matchGalleryHeight = false }) => {
  const cardClassName = matchGalleryHeight
    ? `${styles.testimonialCard} ${styles.testimonialCardMatchGallery}`
    : styles.testimonialCard;

  return (
    <article className={cardClassName}>
      <ProfileSection name={name} role={role} avatar={avatar} />
      <p className={styles.testimonialText}>{text}</p>
      {badge ? <p className={styles.testimonialBadge}>{badge}</p> : null}
    </article>
  );
};

export default TestimonialCard;